<template>
  <div class="modal-container">
    <div class="clearfix">
      <table-header
          @add="insertEvent"
          @remove="removeEvent"
          @copy="copyEvent"
      ></table-header>
    </div>
    <div class="add-box clearfix">
      <vxe-table
          border
          keep-source
          show-overflow
          class="table-style"
          :auto-resize="true"
          ref="xTable"
          max-height="500"
          :show-footer="true"
          :edit-rules="editRules"
          :data="tableData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column
            width="50"
            align="center"
            type="checkbox"
        ></vxe-table-column>

        <vxe-table-column
            width="60"
            align="center"
            type="seq"
            title="序号"
        ></vxe-table-column>
        <vxe-table-column field="paymentsNum" title="详情编号">
          <template v-slot:header="{ column }">
            <span class="column-title"
            >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.paymentsNum" placeholder="必填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersNum" title="订单编号">
          <template v-slot:header="{ column }">
            <span class="column-title"
            >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.ordersNum"
                placeholder="必填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="aboutAmount" title="清分金额">
          <template v-slot:header="{ column }">
            <span class="column-title"
            >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.aboutAmount" placeholder="必填"></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="impotData">上传导入文件</Button>
      <Button status="primary" @click="commit">提 交</Button>
    </div>
    <vxe-modal
        v-model="isShowImportData"
        title="导入明细"
        width="600"
        height="300"
        resize
    >
      <div class="import-goods-box clearfix">
        <a class="import-goods-link" @click="impotEvent">
          <Icon type="md-attach"/>
          选择导入文件</a
        >
        <a
            class="import-goods-down"
            @click.stop="downloadFile('/file/1010新批量清分导入表.xls')"
        >下载模板</a
        >
      </div>
    </vxe-modal>
    <vxe-modal v-model="showTip" title="消息提示" width="600" position="center" height="350"
               remember>
      <Message ref="messageModal" @clear="updatePaymentsOrdersDataNoDelete" @close="showTip = false"
               :isClear="true"></Message>
    </vxe-modal>
  </div>
</template>

<script>
import {
  getExcelTime,
  showLoading,
  hideLoading,
  showFailMsgList,
  isEmpty,
  isNotEmpty,
} from "@/utils/util";
import $api from '@/apiProvider';
import TableHeader from "@/components/common/TableHeader";
import Message from "@/components/common/Message";
import XLSX from "xlsx";

const assign = (o) => Object.assign({}, o);
export default {
  props: {
    isShow: Boolean,
  },
  components: {
    TableHeader,
    Message
  },
  data() {
    return {
      showTip: false,
      tableData: [],
      editRules: {
        paymentsNum: [{validator: this.requireValid}],
        aboutAmount: [{validator: this.requireValid}],
        ordersNum: [{validator: this.requireValid}]
      },
      dataTmp: {
        index: "",
        ordersNumb: null,
        addTime: "",
        fileUuidList: [],
        fileList: [],
        note: null,
      },
      isShowImportData: false,
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val == false && oldVal == true) {
          if (isNotEmpty(this.$refs.xTable)) {
            this.$refs.xTable.clearValidate();
            this.updateFooterEvent();
          }
          this.tableData = [];
        }
        if (val == true) {
          this.insertEvent();
        }
      },
    },
  },
  methods: {
    impotData() {
      this.isShowImportData = true;
    },
    async requireValid(e) {
      if (isEmpty(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + "必填"));
      }
    },
    impotEvent() {
      this.$refs.xTable
          .readFile({
            types: ["xls", "xlsx"],
          })
          .then((evnt) => {
            this.$Spin.show({
              render: (h) => {
                return h("div", [
                  h("Icon", {
                    class: "demo-spin-icon-load",
                    props: {
                      type: "ios-loading",
                      size: 18,
                    },
                  }),
                  h("div", "导入中..."),
                ]);
              },
            });
            const files = evnt.target.files;
            const fileReader = new FileReader();
            this.isImpot = true;
            this.$refs.xTable.remove();

            fileReader.onload = (ev) => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {type: "binary"});
              const csvData = XLSX.utils.sheet_to_csv(
                  Object.values(workbook.Sheets)[0]
              );
              const tableData = [];
              // 解析数据
              csvData.split("\n").forEach((vRow, index) => {
                if (vRow && index > 0) {
                  const vCols = vRow.split(",");
                  const item = {
                    index: index + 1, //需要
                    paymentsNum: vCols[1] ? vCols[1].trim() : null,
                    ordersNum: vCols[2] ? vCols[2].trim() : null,
                    aboutAmount: vCols[3] ? vCols[3].trim() : null,
                  };
                  tableData.push(item);
                }
              });
              this.tableData = tableData;
            };
            fileReader.readAsBinaryString(files[0]);
            setTimeout(() => {
              this.$Spin.hide();
              this.isShowImportData = false;
            }, 1000);
          });
    },
    async validEvent() {
      const errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async commit() {
      this.$refs.xTable.updateStatus();
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return;
      }
      let table = this.$refs.xTable.getTableData();
      let objParams = table.fullData.map(item => {
        return {
          aboutAmount: item.aboutAmount,
          index: item.index,
          ordersNum: item.ordersNum,
          paymentsNum: item.paymentsNum,
        }
      })
      showLoading()
      let res = await $api.twoPayments.request('updatePaymentsOrdersDataNoDelete', objParams)
      hideLoading()
      if (res.status == 1) {
        this.$XModal.message({
          status: "success",
          message: '提交成功'
        })
        this.tableData = []
        this.$emit('close')
      } else if (res.status == 0) {
        showFailMsgList(res.data)
      } else if (res.status === 2) {
        this.objParams = objParams;
        let content = ''
        let errList = res.data;
        errList.forEach((item, index) => {
          let msg = item.failMsg
          content = content + msg + '</br>'
        })
        this.$refs.messageModal.setMessage(content);
        this.showTip = true;
      } else {
        if (!res.message) {
          res.message = '接口异常'
        }
        this.$XModal.message(res.message)
      }
    },
    async updatePaymentsOrdersDataNoDelete() {
      showLoading();
      this.objParams.map(i => {
        i.isForce = 1;
      })
      let reRes = await $api.twoPayments.request("updatePaymentsOrdersDataNoDelete", this.objParams);
      hideLoading();
      if (reRes.status == 1) {
        this.$XModal.message({
          status: "success",
          message: "提交成功",
        });
        this.tableData = [];
        this.showTip = false;
        this.$emit("close");
      } else if (reRes.status == 0) {
        showFailMsgList(reRes.data);
      } else {
        if (!reRes.message) {
          reRes.message = "接口异常";
        }
        this.$XModal.message(reRes.message);
      }
    },
    downloadFile(url) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
    insertEvent() {
      // 插入货物
      let tableData = this.$refs.xTable.getTableData().fullData;
      this.$refs.xTable.clearValidate();
      let record = assign(this.dataTmp);
      record.index = tableData.length + 1;
      this.$refs.xTable.insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      let confirmRes = await this.$XModal.confirm(
          "删除后不可恢复",
          "是否删除？"
      );
      if (confirmRes == "confirm") {
        this.$refs.xTable.removeCheckboxRow();
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      let copyRow = [];
      checkboxRecords.forEach((item) => {
        let paramsObj = {};
        Object.keys(item).forEach((key) => {
          if (key !== "id") {
            paramsObj[key] = item[key];
          }
        });
        copyRow.push(paramsObj);
      });
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      this.$refs.xTable.insertAt(copyRow, -1);
    },
    updateFooterEvent() {
      this.$refs.xTable.updateFooter();
    },
  },
};
</script>

<style>
.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.modal-container {
  position: relative;
  height: 100%;
}
</style>